import { useQuery } from '@hooks/reactQuery';

import { getContactPersons } from '@api/assets';

import { optionsFormattedWithId } from '@utils/formatter';

import { IContactPersons } from '@interfaces/components/form';

import { refetchOptions } from '@constants/common';
import { CONTACT_PERSONS } from '@constants/queryKeys';

export const useQueryContactPersons = () => {
	const {
		data: contactPersonsOptions,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONTACT_PERSONS],
		queryFn: getContactPersons,
		select: (contactPersonsOptions: Array<IContactPersons>) =>
			optionsFormattedWithId<IContactPersons>(contactPersonsOptions),
		...refetchOptions,
	});

	return {
		contactPersonsOptions: contactPersonsOptions || [],
		isLoadingContactPersons: isInitialLoading,
	};
};
